import { Dictionary, SerializableObject } from '../../core';


export class ReportPackageImport extends SerializableObject {
  /**
   * Key of the imported report package.
   */
  public ReportPackageKey: string;

  /**
   * Arguments set on the imported report package.
   */
  public Arguments: Dictionary<string>;
}
